export function getCleanShopName(rawName?: string | null, alias?: string | null): string {
  if (!rawName) return ''
  let n = rawName

  // 1. Dedup trailing repeated parenthetical suffixes
  // e.g. "ブラザーズ（BROZERS）（BROZERS）" → "ブラザーズ（BROZERS）"
  const match = n.match(/^(.+?([（(][^）)]+[）)]))\s*\2\s*$/)
  if (match) n = match[1]

  // 2. Aggressively strip ANY trailing parentheses block completely!
  // The Tabelog translation pipeline almost always appends Romaji or original text in trailing parentheses.
  // Example: "Sushi Jiro (すきやばし次郎)" -> "Sushi Jiro"
  // Example: "シニフィアン シニフィエ 日本橋タカシマヤ店（Signifiant Signifie Nihonbashitakashimayaten）" -> "シニフィアン シニフィエ 日本橋タカシマヤ店"
  const withoutTrailingParen = n.replace(/\s*[（(][^）)]+[）)]\s*$/, '').trim()
  
  // Only apply the strip if we aren't left with an empty string
  if (withoutTrailingParen) {
    n = withoutTrailingParen
  }

  // 3. Fallback: Strip the specific alias if it was appended with a space (no parentheses)
  if (alias && n !== alias) {
    const escapedAlias = alias.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    const spaceRegex = new RegExp(`\\s+${escapedAlias}\\s*$`, 'i')
    if (spaceRegex.test(n)) {
      n = n.replace(spaceRegex, '').trim()
    }
  }

  return n || rawName
}
